import React from 'react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './Routes';



function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;